import { ToastType } from '@components/toast';
import { SystemMaintenanceEventPatchRequestBody } from '@lio/api-types';
import { systemManagementKeys } from '@services/systemManagement/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { useSnackbar } from 'notistack';

export const useUpdateSystemMaintenanceEvent = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (
      request: { body: SystemMaintenanceEventPatchRequestBody } & {
        systemMaintenenceEventId: string;
      },
    ) =>
      client
        .patch(`system-management/system-maintenance-event/${request.systemMaintenenceEventId}`, {
          json: {
            ...request.body,
          },
        })
        .json<any>(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: systemManagementKeys._search() });
      enqueueSnackbar('Maintenance Event Update Successful', {
        variant: ToastType.Success,
      });
    },
  });
  return { ...result, updateSystemMaintenanceEvent: result.mutateAsync };
};
